export const visit = (vm, at) => {
at({ "ja": { "conversationsVisitorUIAvailability": { "sameDay": "\u4ECA\u65E5\u306E{{time}}\u306B\u623B\u308A\u307E\u3059", "nextDay": "\u660E\u65E5\u306E{{time}}\u306B\u623B\u308A\u307E\u3059", "nextWeek": "{{dayOfWeek}}\u306E{{time}}\u306B\u623B\u308A\u307E\u3059" } } });
};